export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/Illustration.f01b4cd.svg";